import React from "react";
import type { QualificationSideBarSelectionType } from "./types";

type QualificationSideBarContextType = {
    qualificationSideBarSelection: QualificationSideBarSelectionType;
    closeQualificationSideBar: () => void;
};

const QualificationSideBarContext = React.createContext<QualificationSideBarContextType>(null);

export default QualificationSideBarContext;
